<template>
  <div class="mobileRgbw">
    <div class="imgBox">
      <img src="../../assets/mobile/product/rgbw.png" class="img" />
    </div>
    <div class="param">
      <div class="title">RGBW灯带</div>
      <div class="tit">相关参数</div>
      <div class="text">
        <div class="left">产品尺寸:</div>
        <div class="right">定制</div>
      </div>
      <div class="text">
        <div class="left">额定电压:</div>
        <div class="right">3V</div>
      </div>
      <div class="text">
        <div class="left">额定输入:</div>
        <div class="right">DC12V/24V</div>
      </div>
      <div class="text">
        <div class="left">额定功率:</div>
        <div class="right">5W/米</div>
      </div>
      <div class="text">
        <div class="left">工作温度:</div>
        <div class="right">0°C-40°C</div>
      </div>
      <div class="text">
        <div class="left">工作湿度:</div>
        <div class="right">0%-95%RH，无冷凝</div>
      </div>          
    </div>
    <div class="paramDe">
      <div
        class="txt"
      >RGBW灯带，需要配合集中式LED调色控制器，RGBW灯带可以实现红、绿、蓝、白四种颜色，可以依次变幻、跑马和闪烁等效果。</div>
      <div class="data">
        <img src="../../assets/mobile/dataImg.png" class="dataImg" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {}
};
</script>
<style scoped lang="less">
.mobileRgbw {
  background-color: #fff;
  .imgBox {
    width: 100%;
    padding-top: 0.97rem;
    padding-bottom:0.99rem;
    display: flex;
    justify-content: center;
    .img {
      width: 3.9rem;
      height: 2.46rem;
    }
  }
  .param {
    text-align: left;
    margin: 0 0.3rem;
    padding-bottom: 0.29rem;
    border-bottom: 1px solid #333;
    .title {
      font-size: 0.36rem;
      line-height: 0.36rem;
      font-weight: 400;
      color: #ff9000;
      padding-bottom: 0.2rem;
      border-bottom: 1px solid #333;
    }
    .tit {
      margin-top: 0.17rem;
      font-size: 0.36rem;
      line-height: 0.36rem;
      font-weight: bold;
      color: #333333;
      margin-bottom: 0.6rem;
    }
    .text {
      margin-top: 0.36rem;
      display: flex;
      font-size: 0.24rem;
      line-height: 0.24rem;
      font-weight: 400;
      color: #333333;
      &:first-of-type {
        margin-top: 0;
      }
      .left {
        // width: 2.5rem;
        text-align: right;
      }
      .right {
        margin-left: 0.59rem;
      }
    }
  }
  .paramDe {
    margin-top: 0.3rem;
    padding: 0 0.3rem;
    .txt {
      font-size: 0.24rem;
      font-weight: 400;
      color: #333333;
      line-height: 0.4rem;
      text-align: justify;
    }
    .data {
      width: 6.45rem;
      margin-top: 0.39rem;
      padding-bottom: 0.8rem;
      display: flex;

      .dataImg {
        width: 100%;
        height: 0.18rem;
      }
    }
  }
}
</style>